// #region Imports

import Vue from 'vue';
import BarSelect from '../components/forms/BarSelect.vue';
import BaseBadge from '../components/base/BaseBadge.vue';
import BaseButton from '../components/forms/base/BaseButton.vue';
import BaseButtonV2 from '../components/forms/base/BaseButtonV2.vue';
import BaseCard from '../components/base/BaseCard.vue';
import BaseCardTabs from '../components/base/BaseCardTabs.vue';
import BaseChart from '../components/base/BaseChart.vue';
import BaseCheckbox from '../components/forms/base/BaseCheckbox.vue';
import BaseContextButton from '../components/base/BaseContextButton.vue';
import BaseContextMenu from '../components/base/BaseContextMenu.vue';
import BaseDateTimePicker from '../components/forms/base/BaseDateTimePicker.vue';
import BaseFileInput from '../components/forms/base/BaseFileInput.vue';
import BaseFilter from '../components/base/BaseFilter.vue';
import BaseForm from '../components/forms/base-form/BaseForm.vue';
import BaseFormControls from '../components/forms/BaseFormControls.vue';
import BaseGrid from '../components/base/BaseGrid.vue';
import BaseIcon from '../components/base/BaseIcon.vue';
import BaseIconCard from '../components/base/BaseIconCard.vue';
import BaseImage from '../components/base/BaseImage.vue';
import BaseInput from '../components/forms/base/BaseInput.vue';
import BaseInputSelect from '../components/forms/base/BaseInputSelect.vue';
import BaseInputSection from '../components/forms/BaseInputSection.vue';
import BaseJson from '../components/base/BaseJson.vue';
import BaseList from '../components/forms/base/BaseList.vue';
import BaseModal from '../components/base/BaseModal.vue';
import BaseModalV2 from '@/components/BaseModalV2.vue';
import BasePagination from '../components/base/BasePagination.vue';
import BaseRadio from '../components/forms/base/BaseRadio.vue';
import BaseSelect from '../components/forms/base/BaseSelect.vue';
import BaseSpacer from '../components/base/BaseSpacer.vue';
import BaseStateSwitch from '../components/forms/base/BaseStateSwitch.vue';
import BaseStepper from '../components/base/BaseStepper.vue';
import BaseSwitch from '../components/forms/base/BaseSwitch.vue';
import BaseTable from '../components/base/BaseTable.vue';
import BaseTabs from '../components/base/BaseTabs.vue';
import BaseTags from '../components/forms/base/BaseTags.vue';
import BaseTextarea from '../components/forms/base/BaseTextarea.vue';
import BaseTooltip from '../components/base/BaseTooltip.vue';
import BaseVerticalTable from '../components/base/BaseVerticalTable.vue';
import BaseVerticalTableV2 from '../components/base/BaseVerticalTableV2.vue';
import CardGrid from '../components/CardGrid.vue';
import ContactForm from '../components/ContactForm.vue';
import CustomExpansion from '../components/CustomExpansion.vue';
import Expansion from '../common/Expansion.vue';
import Group from '../components/Group.vue';
import Hover from '../components/base/Hover.vue';
import IconCard from '../common/Card.vue';
import IoBaseSelect from '../components/forms/IoBaseSelect.vue';
import IoBaseTable from '../components/IoBaseTable.vue';
import IoButton from '../components/IoButton.vue';
import IoColor from '../components/forms/IoColor.vue';
import IoExpansionPanel from '../components/IoExpansionPanel.vue';
import IoIcon from '../components/IoIcon.vue';
import IoInput from '../components/forms/IoInput.vue';
import IoTextarea from '../components/forms/IoTextarea.vue';
import InfinityScroll from '../components/InfinityScroll.vue';
import BaseLoginForm from '../components/BaseLoginForm.vue';
import RichTextEditor from '../components/forms/rte/RichTextEditor.vue';
import SimpleList from '../components/base/SimpleList.vue';
import SimpleDynamicForm from '../components/SimpleDynamicForm.vue';
import ContactPartnerForm from '../order/components/partner/ContactPartnerForm.vue';

// #endregion

// #region Component Registration

Vue.component('BarSelect', BarSelect);
Vue.component('BaseBadge', BaseBadge);
Vue.component('BaseButton', BaseButton);
Vue.component('BaseButtonV2', BaseButtonV2);
Vue.component('BaseCard', BaseCard);
Vue.component('BaseCardTabs', BaseCardTabs);
Vue.component('BaseChart', BaseChart);
Vue.component('BaseCheckbox', BaseCheckbox);
Vue.component('BaseContextButton', BaseContextButton);
Vue.component('BaseContextMenu', BaseContextMenu);
Vue.component('BaseDateTimePicker', BaseDateTimePicker);
Vue.component('BaseFileInput', BaseFileInput);
Vue.component('BaseFilter', BaseFilter);
Vue.component('BaseForm', BaseForm);
Vue.component('BaseFormControls', BaseFormControls);
Vue.component('BaseGrid', BaseGrid);
Vue.component('BaseIcon', BaseIcon);
Vue.component('BaseIconCard', BaseIconCard);
Vue.component('BaseImage', BaseImage);
Vue.component('BaseInput', BaseInput);
Vue.component('BaseInputSelect', BaseInputSelect);
Vue.component('BaseInputSection', BaseInputSection);
Vue.component('BaseJson', BaseJson);
Vue.component('BaseList', BaseList);
Vue.component('BaseModal', BaseModal);
Vue.component('BaseModalV2', BaseModalV2);
Vue.component('BasePagination', BasePagination);
Vue.component('BaseRadio', BaseRadio);
Vue.component('BaseSelect', BaseSelect);
Vue.component('BaseSpacer', BaseSpacer);
Vue.component('BaseStateSwitch', BaseStateSwitch);
Vue.component('BaseStepper', BaseStepper);
Vue.component('BaseSwitch', BaseSwitch);
Vue.component('BaseTable', BaseTable);
Vue.component('BaseTabs', BaseTabs);
Vue.component('BaseTags', BaseTags);
Vue.component('BaseTextarea', BaseTextarea);
Vue.component('BaseTooltip', BaseTooltip);
Vue.component('BaseVerticalTable', BaseVerticalTable);
Vue.component('BaseVerticalTableV2', BaseVerticalTableV2);
Vue.component('CardGrid', CardGrid);
Vue.component('ContactForm', ContactForm);
Vue.component('CustomExpansion', CustomExpansion);
Vue.component('Expansion', Expansion);
Vue.component('Group', Group);
Vue.component('Hover', Hover);
Vue.component('IconCard', IconCard);
Vue.component('IoBaseSelect', IoBaseSelect);
Vue.component('IoBaseTable', IoBaseTable);
Vue.component('IoButton', IoButton);
Vue.component('IoColor', IoColor);
Vue.component('IoExpansionPanel', IoExpansionPanel);
Vue.component('IoIcon', IoIcon);
Vue.component('IoInput', IoInput);
Vue.component('IoTextarea', IoTextarea);
Vue.component('InfinityScroll', InfinityScroll);
Vue.component('BaseLoginForm', BaseLoginForm);
Vue.component('RichTextEditor', RichTextEditor);
Vue.component('SimpleList', SimpleList);
Vue.component('SimpleDynamicForm', SimpleDynamicForm);
Vue.component('ContactPartnerForm', ContactPartnerForm);

// #endregion
